// Mirrors ChatbotPathVisibility.isUrl in the backend.
const URL_PREFIX = /^(?:[a-zA-Z][a-zA-Z0-9+.-]*:)?\/\//;

export default function isUrl(raw: string): boolean {
  return URL_PREFIX.test(raw.trim());
}
